export const DYNAMIC_GREETING_URLS = {
  chooseTransaction: '/private/partmoneymovement/managemymoney/choosetransaction'
};
